import { Card } from "../../../components/ui/card";
import { centsToCurrency } from "../../utils/money";

interface PlanStatsChartProps {
  lang: "pt" | "en";
  t: any;
  loadingPlans: boolean;
  planItems: any[];
}

export function PlanStatsChart({ lang, t, loadingPlans, planItems }: PlanStatsChartProps) {
  const planMax = Math.max(1, ...planItems.map((i) => i.count));

  return (
    <Card>
      <div className="p-4">
        <div className="text-xs text-neutral-500 mb-2">{t.dashboard.plansNote}</div>
        {loadingPlans ? (
          <div>{t.common.loading}</div>
        ) : planItems.length === 0 ? (
          <div>{t.common.none}</div>
        ) : (
          <div className="h-48 flex items-end gap-4">
            {planItems.map((it) => {
              const pct = (it.count / planMax) * 100;
              return (
                <div key={it.label} className="flex-1 flex flex-col items-center">
                  <div className="text-sm mb-1">{it.count}</div>
                  <div className="w-full flex-1 flex items-end bg-neutral-200 rounded">
                    <div
                      className="w-full rounded"
                      style={{ height: `calc(${pct}% + ${it.count > 0 ? 1 : 0}px)`, background: it.color }}
                    />
                  </div>
                  <div className="mt-2 text-xs text-center">{it.label}</div>
                  <div className="text-[10px] text-neutral-500">{centsToCurrency(it.total, lang)}</div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </Card>
  );
}
